export default "{\n    \"FINDING_VENDOR\": \"Buscando proveedor\",\n    \"FINDING_QUOTE\": \"Buscando estimación\",\n    \"UNKNOWN\": \"Desconocido\"\n}\n"